"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  z-index: 9;\n  position: absolute;\n  left: 50%;\n  bottom: 100%;\n  opacity: ", ";\n  margin-bottom: 1em;\n  padding: 1em;\n  background-color: #11141c;\n  width: 600px;\n  border-radius: 5px;\n  transform: ", ";\n\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 1.8rem;\n  color: white;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border: 0.5em solid transparent;\n    border-top-color: #11141c;\n    -webkit-transform: translate(-50%, 0);\n    transform: translate(-50%, 0);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  z-index: 10;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 9999px;\n  border: 1.5px solid #8990a3;\n  justify-content: center;\n  align-items: center;\n  font-family: ", ";\n  font-size: 1.2rem;\n  line-height: 1.5rem;\n  color: #8990a3;\n\n  &:hover {\n    color: ", ";\n    border: 1.5px solid ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  -webkit-box-pack: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  outline: none;\n  appearance: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tooltip = function Tooltip(_ref) {
  var className = _ref.className,
      toggleIcon = _ref.toggleIcon,
      children = _ref.children,
      onClick = _ref.onClick,
      otherProps = _objectWithoutProperties(_ref, ["className", "toggleIcon", "children", "onClick"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  return _react.default.createElement(TooltipWrapper, _extends({
    onMouseLeave: function onMouseLeave() {
      return setIsActive(false);
    },
    className: className,
    onClick: onClick
  }, otherProps), _react.default.createElement(TooltipToggle, {
    onMouseMove: function onMouseMove() {
      return setIsActive(true);
    }
  }, toggleIcon), _react.default.createElement(TooltipContent, {
    active: isActive
  }, children));
};

var TooltipWrapper = _styledComponents.default.div(_templateObject());

var TooltipToggle = _styledComponents.default.a(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.brand.primary;
});

var TooltipContent = _styledComponents.default.div(_templateObject3(), function (_ref5) {
  var active = _ref5.active;
  return active ? '1' : '0';
}, function (_ref6) {
  var active = _ref6.active;
  return active ? 'translate(-50%, 0)' : 'translate(-50%, 1em)';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.font;
});

Tooltip.defaultProps = {
  toggleIcon: '?',
  children: 'Please provide text to be shown inside the tooltip.'
};
Tooltip.propTypes = {
  /** Extra class to be passed to the component. */
  className: _propTypes.string,

  /** Icon to be shown inside the toggle. (String) */
  toggleIcon: _propTypes.string.isRequired,

  /** Content to be shown inside the toggle.  */
  children: _propTypes.node.isRequired,

  /** Optional onClick function to be passed. */
  onClick: _propTypes.func,

  /** Extra props to be passed to the component. */
  otherProps: _propTypes.object
};
var _default = Tooltip;
exports.default = _default;